import React from "react";
import boltHoleCrack from "./assets/1-boltHoleCrack.jpg";
import brokenBase from "./assets/2-brokenBase.jpg";
import brokenRailAndOrdinaryBreak from "./assets/3-brokenRailAndOrdinaryBreak.jpg";
import crushedRailHead from "./assets/4-crushedRailHead.jpg";
import damagedRail from "./assets/5-damagedRail.jpg";
import engineBurnFracture from "./assets/6-engineBurnFracture.jpg";
import headAndWebSeparation from "./assets/7-headAndWebSeparation.jpg";
import horizontalSplitHead from "./assets/8-horizontalSplitHead.jpg";
import pipedRail from "./assets/9-pipedRail.jpg";
import splitWeb from "./assets/10-splitWeb.jpg";
import transverseDefectOrDetailedFracture from "./assets/11-transverseDefectOrDetailedFracture.jpg";
import transverseDefectUnderWeldRepair from "./assets/12-transverseDefectUnderWeldRepair.jpg";
import transverseFissureOrCompoundFissure from "./assets/13-transverseFissureOrCompoundFissure.jpg";
import verticalSplitHead from "./assets/14-verticalSplitHead.jpg";

export const onrInServiceRailFailureReportinstrucions = {
  "1a": {
    span:
      "(a) One side of the rail is branded on the web with the name of the manufacturer and/or mill, the weight and section of the\
        rail, and year and month of rolling. A manufacturer's section number may be added. Where a special steel or process is used,\
        letters are used to so indicate as follows:",
    letters: [
      {
        abrev: "OH",
        desctiption:
          "Steel manufactured by the Open Hearth process. Rail marked 'OH' produced by Canadian mills is not controlled cooled, \
            but rail from US mills produced after about 1934 - 37 is. Rail branded to indicate one of the various controlled cooling \
            processes, or 'VT' or 'BC' will not bear this mark.",
      },
      null,
      {
        abrev: "Mackie",
        desctiption: "",
      },
      {
        abrev: "M",
        desctiption: "Rail treated by the",
      },
      {
        abrev: "MRC",
        desctiption: "controlled cooled",
      },
      {
        abrev: "RC",
        desctiption: "(retarded cooled) process",
      },
      {
        abrev: "CC",
        desctiption: "",
      },
      null,
      {
        abrev: "VT",
        desctiption: "Steel vacuum treated in the liquid stage",
      },
      null,
      {
        abrev: "BC",
        desctiption: "Bloom cooled",
      },
      null,
    ],
  },
  "1b": {
    span: "(b) Until recently, section numbers were used by Canadian manufacturers for common rail sections",
    table: {
      schema: {
        heights: {
          header1: "auto",
          header2: "auto",
        },
        minDataRowsCount: 10,
        columns: [
          {
            title: "Weight & Section",
            colSpan: 1,
            rowSpan: 2,
            className: "tbl-text-normal",
            accessor: "was",
          },
          {
            title: "Manufacturer's Name and Section Number",
            colSpan: 2,
            rowSpan: 1,
            className: "tbl-text-normal",
            columns: [
              {
                title: "D.I. & S Co. - Dominion - Dosco - Sysco - Sydney",
                colSpan: 1,
                rowSpan: 1,
                className: "tbl-text-normal",
                accessor: "di",
              },
              {
                title: "Algoma",
                colSpan: 1,
                rowSpan: 1,
                className: "tbl-text-normal",
                accessor: "alg",
              },
            ],
          },
        ],
      },
      data: [
        { was: "115 RE", di: 11501, alg: 145 },

        { was: "100 RE HF", di: 10005, alg: 142 },

        { was: "100 RE", di: 10003, alg: "---" },

        { was: "100 ARA-A HF", di: 10004, alg: 136 },

        { was: "100 ARA-A", di: 10002, alg: 120 },

        { was: "100 ASCE", di: 10001, alg: 109 },

        { was: "90 ARA-A", di: 9002, alg: "---" },

        { was: "85 CP HF", di: 8504, alg: 137 },

        { was: "85 CP Std.", di: 8501, alg: 113 },

        { was: "80 ASCE", di: 8001, alg: 100 },

        { was: "80 Can. Nor.", di: 8003, alg: 115 },
      ],
    },
  },
  2: {
    span1:
      "The other side of the rail is stamped with details of the controlled cooling process (if not given on the brand side), \
      the alloy if any, and the heat number, ingot number and rail letter.",
    span2:
      "In rails produced in Canada the sequence is heat number, ingot number - rail letter, but in the U.S. and generally \
        elsewhere in the world the sequence is heat number - rail letter - ingot number.",
    span3:
      "For rails produced from continuous strand cast blooms an additional number must be introduced in the sequence to indicate \
        the strand number, and the ingot number is replaced by a bloom number.",
  },
};

const RenderDefectDescAndSvg = (values) => {
  const [desc, svg] = values;

  return (
    <div>
      <div style={{ float: "left", display: "inline-block", padding: "10px", height: "64px", lineHeight: "44px" }}>{desc}</div>
      {svg ? (
        <div style={{ float: "right", display: "inline-block", paddingRight: "10px" }}>
          <img src={svg} alt={"desc"} style={{ height: "60px", margin: "2px" }} />
        </div>
      ) : null}
    </div>
  );
};

export const onrInServiceRailFailureReportDefects = {
  schema: {
    heights: {
      header1: "auto",
    },
    minDataRowsCount: 1,
    columns: [
      {
        title: "DESCRIPTION",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: ["defect1Desc", "defect1Svg"],
        dontJoinValues: true,
        formatter: RenderDefectDescAndSvg,
      },
      {
        title: "DESCRIPTION",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: ["defect2Desc", "defect2Svg"],
        dontJoinValues: true,
        formatter: RenderDefectDescAndSvg,
      },
    ],
  },
  data: [
    { defect1Desc: "Bolt Hole Crack", defect1Svg: boltHoleCrack, defect2Desc: "Horizontal Split Head", defect2Svg: horizontalSplitHead },
    { defect1Desc: "Broken Base", defect1Svg: brokenBase, defect2Desc: "Piped Rail", defect2Svg: pipedRail },
    {
      defect1Desc: "Broken Rail And Ordinary Break",
      defect1Svg: brokenRailAndOrdinaryBreak,
      defect2Desc: "Split Web",
      defect2Svg: splitWeb,
    },
    {
      defect1Desc: "Crushed Rail Head",
      defect1Svg: crushedRailHead,
      defect2Desc: "Transverse Defect Or Detailed Fracture",
      defect2Svg: transverseDefectOrDetailedFracture,
    },
    {
      defect1Desc: "Damaged Rail",
      defect1Svg: damagedRail,
      defect2Desc: "Transverse Defect Under Weld Repair",
      defect2Svg: transverseDefectUnderWeldRepair,
    },
    {
      defect1Desc: "Defective Field Weld or Defective Plant Weld",
      defect1Svg: null,
      defect2Desc: "Transverse Fissure Or Compound Fissure",
      defect2Svg: transverseFissureOrCompoundFissure,
    },
    {
      defect1Desc: "Engine Burn Fracture",
      defect1Svg: engineBurnFracture,
      defect2Desc: "Vertical Split Head",
      defect2Svg: verticalSplitHead,
    },
    {
      defect1Desc: "Head And Web Separation",
      defect1Svg: headAndWebSeparation,
      defect2Desc: "Excessive Wear",
      defect2Svg: null,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/InServiceRailFailureReport/instructionsList.js